<template>
  <div>
    <div class="management_top_box">
      <h4>{{ $t("management.productTypeManagement") }}</h4>
      <div class="m_t_right">
        <!-- <dl>
          <dt>Language:</dt>
          <select
            name="language"
            class="int_type01 mgt_seltype"
            v-model="form.selectedLanguage"
            @change="changeLang()"
          >
            <option
              v-for="(item, index) in languages"
              :key="index"
              v-bind:value="item.codeId"
            >
              {{ item.codeName }}
            </option>
          </select>
        </dl> -->
        <button
          type="button"
          class="btn btn-secondary btn-sm m-2"
          @click="downExcel()"
          style="margin: 11px 0 0 0 !important"
        >
          <span class="bt_icon download_icon">Download</span>Excel Download
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 col-lg-6 col-xl-12 col-xxl-6">
        <div class="mgt_group_box">
          <div class="mgt_group_title">
            <h4>{{ $t("management.mainClass") }}</h4>
            <div class="group_bt_box">
              <a
                href="javascript:void(0)"
                class="mgt_g_icon01"
                @click="showChangeOrder01()"
                title="순위변경"
                >순위변경</a
              >
              <a
                href="javascript:void(0)"
                class="mgt_g_icon02"
                @click="showAdd01Popup()"
                title="Type 추가"
              >
                추가
              </a>
              <a
                href="javascript:void(0)"
                class="mgt_g_icon03"
                @click="showUpdateProd01Popup(form.Type01Id)"
                title="수정"
                >수정</a
              >
              <a
                href="javascript:void(0)"
                class="mgt_g_icon04"
                @click="deleteType(form.Type01Id, 'prod')"
                title="삭제"
                >삭제</a
              >
            </div>
          </div>
          <div class="mgt_list">
            <ul v-if="prod01List">
              <li v-for="(item, index) in prod01List" :key="index">
                <em
                  class="pointer_cursor"
                  v-on:click="changeType01(item.prodId)"
                  v-bind:class="{ on: item.prodId === form.Type01Id }"
                >
                  {{ item.prodName }}
                </em>
                <p>
                  <!--                  TODO : 이미지 html 바꾸기-->
                  <button
                    type="button"
                    id=""
                    class="switch_btn"
                    data-toggle="button"
                    aria-pressed="false"
                    @click="
                      item.useYn = item.useYn === 'Y' ? 'N' : 'Y';
                      toggleUseYN(item.prodId, item.useYn, 'prod');
                    "
                    v-bind:class="{ active: item.useYn === 'Y' }"
                  >
                    <span></span>
                  </button>
                  <!-- <span @click="showPreviewPopup(item.doctypeId)">이미지</span> -->
                  <span class="img_box" @click="showPreviewPopup(item.prodId)"
                    >이미지</span
                  >
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-lg-6 col-xl-12 col-xxl-6">
        <div class="mgt_group_box">
          <div class="mgt_group_title">
            <h4>{{ $t("management.subClass") }}</h4>
            <div class="group_bt_box">
              <a
                href="javascript:void(0)"
                class="mgt_g_icon01"
                @click="showChangeOrder02()"
                title="순위변경"
                >순위변경</a
              >
              <a
                href="javascript:void(0)"
                class="mgt_g_icon02"
                @click="showAdd02Popup()"
                title="Type 추가"
                >추가</a
              >
              <a
                href="javascript:void(0)"
                class="mgt_g_icon03"
                @click="showUpdateProd02Popup(form.Type02Id)"
                title="수정"
                >수정</a
              >
              <a
                href="javascript:void(0)"
                class="mgt_g_icon04"
                @click="deleteType(form.Type02Id, 'prod')"
                title="삭제"
                >삭제</a
              >
            </div>
          </div>
          <div class="mgt_list">
            <ul v-if="prod02List">
              <li v-for="(item, index) in prod02List" :key="index">
                <em
                  class="pointer_cursor"
                  v-on:click="changeType02(item.prodId)"
                  v-bind:class="{ on: item.prodId === form.Type02Id }"
                >
                  {{ item.prodName }}
                </em>
                <p>
                  <button
                    type="button"
                    id=""
                    class="switch_btn"
                    data-toggle="button"
                    aria-pressed="false"
                    @click="
                      item.useYn = item.useYn === 'Y' ? 'N' : 'Y';
                      toggleUseYN(item.prodId, item.useYn, 'prod');
                    "
                    v-bind:class="{ active: item.useYn === 'Y' }"
                  >
                    <span></span>
                  </button>
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="management_top_box">
      <h4>{{ $t("product.otherManagement") }}</h4>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-6 col-xl-12 col-xxl-6">
        <div class="mgt_group_box">
          <div class="mgt_group_title">
            <h4>{{ $t("product.equipmentCode") }}</h4>
            <div class="group_bt_box">
              <a
                href="javascript:void(0)"
                class="mgt_g_icon01"
                @click="showChangeOrderModel()"
                title="순위변경"
                >순위변경</a
              >
              <a
                href="javascript:void(0)"
                class="mgt_g_icon02"
                @click="showAddModelCodePopup()"
                title="Type 추가"
              >
                추가
              </a>
              <a
                href="javascript:void(0)"
                class="mgt_g_icon03"
                @click="showUpdateModelCodePopup(form.modelCodeId)"
                title="수정"
                >수정</a
              >
              <a
                href="javascript:void(0)"
                class="mgt_g_icon04"
                @click="deleteType(form.modelCodeId, 'model')"
                title="삭제"
                >삭제</a
              >
            </div>
          </div>
          <div class="mgt_list">
            <ul v-if="modelCodeList">
              <li v-for="(item, index) in modelCodeList" :key="index">
                <em
                  class="pointer_cursor"
                  v-on:click="changeModelCode(item.modelcodeId)"
                  v-bind:class="{ on: item.modelcodeId === form.modelCodeId }"
                >
                  {{ item.modelcodeName }}
                </em>
                <p>
                  <button
                    type="button"
                    id=""
                    class="switch_btn"
                    data-toggle="button"
                    aria-pressed="false"
                    @click="
                      item.useYn = item.useYn === 'Y' ? 'N' : 'Y';
                      toggleUseYN(item.modelcodeId, item.useYn, 'model');
                    "
                    v-bind:class="{ active: item.useYn === 'Y' }"
                  >
                    <span></span>
                  </button>
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-lg-6 col-xl-12 col-xxl-6">
        <div class="mgt_group_box">
          <div class="mgt_group_title">
            <h4>{{ $t("management.exhaustCertification") }}</h4>
            <div class="group_bt_box">
              <a
                href="javascript:void(0)"
                class="mgt_g_icon01"
                @click="showChangeOrderExCerti()"
                title="순위변경"
                >순위변경</a
              >
              <a
                href="javascript:void(0)"
                class="mgt_g_icon02"
                @click="showAddExCertificationPopup()"
                title="Type 추가"
              >
                추가
              </a>
              <a
                href="javascript:void(0)"
                class="mgt_g_icon03"
                @click="showUpdateExCertiPopup(form.exhaustCertiId)"
                title="수정"
                >수정</a
              >
              <a
                href="javascript:void(0)"
                class="mgt_g_icon04"
                @click="deleteType(form.exhaustCertiId, 'exhaust')"
                title="삭제"
                >삭제</a
              >
            </div>
          </div>
          <div class="mgt_list">
            <ul v-if="exhaustCertiList">
              <li v-for="(item, index) in exhaustCertiList" :key="index">
                <em
                  class="pointer_cursor"
                  v-on:click="changeExCerti(item.exhaustCertiId)"
                  v-bind:class="{ on: item.exhaustCertiId === form.exhaustCertiId }"
                >
                  {{ item.exhaustCertiName }}
                </em>
                <p>
                  <button
                    type="button"
                    id=""
                    class="switch_btn"
                    data-toggle="button"
                    aria-pressed="false"
                    @click="
                      item.useYn = item.useYn === 'Y' ? 'N' : 'Y';
                      toggleUseYN(item.exhaustCertiId, item.useYn, 'exhaust');
                    "
                    v-bind:class="{ active: item.useYn === 'Y' }"
                  >
                    <span></span>
                  </button>
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

     <!--2023.12.26 tsg mgmt 추가----------------->
    <div class="management_top_box">
      <h4>{{ $t("product.controllerTypeManagement") }}</h4>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-6 col-xl-12 col-xxl-6">
        <div class="mgt_group_box">
          <div class="mgt_group_title">
            <h4>{{ $t("product.controllerType") }}</h4>
            <div class="group_bt_box">
              <a
                href="javascript:void(0)"
                class="mgt_g_icon01"
                @click="showChangeOrderControllerType()"
                title="순위변경"
                >순위변경</a
              >
              <a
                href="javascript:void(0)"
                class="mgt_g_icon02"
                @click="showAddControllerType()"
                title="Type 추가"
              >
                추가
              </a>
              <a
                href="javascript:void(0)"
                class="mgt_g_icon03"
                @click="showUpdateControllerType(form.controllerTypeId)"
                title="수정"
                >수정</a
              >
              <a
                href="javascript:void(0)"
                class="mgt_g_icon04"
                @click="deleteType(form.controllerTypeId, 'controller')"
                title="삭제"
                >삭제</a
              >
            </div>
          </div>
          <div class="mgt_list">
            <ul v-if="controllerTypeList">
              <li v-for="(item, index) in controllerTypeList" :key="index">
                <em
                  class="pointer_cursor"
                  v-on:click="changeControllerTypeId(item.controllerId)"
                  v-bind:class="{ on: item.controllerId === form.controllerTypeId }"
                >
                  {{ item.controllerName }}
                </em>
                <p>
                  <button
                    type="button"
                    id=""
                    class="switch_btn"
                    data-toggle="button"
                    aria-pressed="false"
                    @click="
                      item.useYn = item.useYn === 'Y' ? 'N' : 'Y';
                      toggleUseYN(item.controllerId, item.useYn, 'controller');
                    "
                    v-bind:class="{ active: item.useYn === 'Y' }"
                  >
                    <span></span>
                  </button>
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-lg-6 col-xl-12 col-xxl-6">
        <div class="mgt_group_box">
          <div class="mgt_group_title">
            <h4>{{ $t("product.sourceTpcd") }}</h4>
            <div class="group_bt_box">
              <a
                href="javascript:void(0)"
                class="mgt_g_icon01"
                @click="showChangeOrderTpcd()"
                title="순위변경"
                >순위변경</a
              >
              <a
                href="javascript:void(0)"
                class="mgt_g_icon02"
                @click="showAddTpcdPopup()"
                title="Type 추가"
              >
                추가
              </a>
              <a
                href="javascript:void(0)"
                class="mgt_g_icon03"
                @click="showUpdateTpcdPopup(form.tpcdId)"
                title="수정"
                >수정</a
              >
              <a
                href="javascript:void(0)"
                class="mgt_g_icon04"
                @click="deleteType(form.tpcdId, 'tpcd')"
                title="삭제"
                >삭제</a
              >
            </div>
          </div>
          <div class="mgt_list">
            <ul v-if="sourceTpcdList">
              <li v-for="(item, index) in sourceTpcdList" :key="index">
                <em
                  class="pointer_cursor"
                  v-on:click="changeTpcdId(item.tpcdId)"
                  v-bind:class="{ on: item.tpcdId === form.tpcdId }"
                >
                  {{ item.tpcdName }}
                </em>
                <p>
                  <button
                    type="button"
                    id=""
                    class="switch_btn"
                    data-toggle="button"
                    aria-pressed="false"
                    @click="
                      item.useYn = item.useYn === 'Y' ? 'N' : 'Y';
                      toggleUseYN(item.tpcdId, item.useYn, 'tpcd');
                    "
                    v-bind:class="{ active: item.useYn === 'Y' }"
                  >
                    <span></span>
                  </button>
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <AddProdtypeModal
      id="addProdtypeModal"
      ref="addProdtypeModal"
      v-show="showProdModal"
      @close="showProdModal == false"
    >
      <template slot="footer">
        <button
          type="button"
          @click="saveProdType"
          class="btn btn-primary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="closeAddProdtypeModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </AddProdtypeModal>
    <AddProdtypeModal
      id="addProdtype02Modal"
      ref="addProdtype02Modal"
      v-show="showProd2Modal"
      @close="showProd2Modal == false"
    >
      <template slot="footer">
        <button
          type="button"
          @click="saveProdType02"
          class="btn btn-primary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="closeAddProdtype02Modal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </AddProdtypeModal>
    <AddModelCodeModal
      id="addModelCodeModal"
      ref="addModelCodeModal"
      v-show="showModelModal"
      @close="showModelModal == false"
    >
      <template slot="footer">
        <button
          type="button"
          @click="saveModelCode"
          class="btn btn-primary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="closeAddModelCodeModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </AddModelCodeModal>
    <AddExCertificationModal
      id="addExCertificationModal"
      ref="addExCertificationModal"
      v-show="showExModal"
      @close="showExModal == false"
    >
      <template slot="footer">
        <button
          type="button"
          @click="saveExCertification"
          class="btn btn-primary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="closeAddExCertificationModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </AddExCertificationModal>
    <UpdateProdtypeModal
      id="updateProdtype01Modal"
      ref="updateProdtype01Modal"
      v-show="showUpdateProdModal"
      @close="showUpdateProdModal == false"
    >
      <template slot="footer">
        <button
          type="button"
          @click="updateProdtype01"
          class="btn btn-primary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="closeUpdateProdtype01Modal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </UpdateProdtypeModal>
    <UpdateProdtypeModal
      id="updateProdtype02Modal"
      ref="updateProdtype02Modal"
      v-show="showUpdateProdModal2"
      @close="showUpdateProdModal2 == false"
    >
      <template slot="footer">
        <button
          type="button"
          @click="updateProdtype02"
          class="btn btn-primary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="closeUpdateProdtype02Modal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </UpdateProdtypeModal>
    <UpdateModelCodeModal
      id="updateModelCodeModal"
      ref="updateModelCodeModal"
      v-show="showUpdateModelModal"
      @close="showUpdateModelModal == false"
    >
      <template slot="footer">
        <button
          type="button"
          @click="updateModelCode"
          class="btn btn-primary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="closeUpdateModelCodeModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </UpdateModelCodeModal>
    <UpdateExCertiModal
      id="updateExCertiModal"
      ref="updateExCertiModal"
      v-show="showUpdateExModal"
      @close="showUpdateExModal == false"
    >
      <template slot="footer">
        <button
          type="button"
          @click="updateExCerti"
          class="btn btn-primary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="closeUpdateExCertiModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </UpdateExCertiModal>
    <ProdChangeOrderModal
      id="changeOrderModal01"
      ref="changeOrderModal01"
      v-show="showOrderModal1"
      @close="showOrderModal1 == false"
    >
      <template slot="footer">
        <button
          type="button"
          @click="changeOrder01"
          class="btn btn-primary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="closeChangeOrderModal01"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </ProdChangeOrderModal>
    <ProdChangeOrderModal
      id="changeOrderModal02"
      ref="changeOrderModal02"
      v-show="showOrderModal2"
      @close="showOrderModal2 == false"
    >
      <template slot="footer">
        <button
          type="button"
          @click="changeOrder02"
          class="btn btn-primary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="closeChangeOrderModal02"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </ProdChangeOrderModal>
    <ModelChangeOrderModal
      id="modelChangeOrderModal"
      ref="modelChangeOrderModal"
      v-show="showModelOrderModal"
      @close="showModelOrderModal == false"
    >
      <template slot="footer">
        <button
          type="button"
          @click="changeModelCodeOrder"
          class="btn btn-primary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="closeModelChangeOrderModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </ModelChangeOrderModal>
    <ExCertiChangeOrderModal
      id="exCertiChangeOrderModal"
      ref="exCertiChangeOrderModal"
      v-show="showExOrderModal"
      @close="showExOrderModal == false"
    >
      <template slot="footer">
        <button
          type="button"
          @click="changeExCertiOrder"
          class="btn btn-primary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="closeExCertiChangeOrderModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </ExCertiChangeOrderModal>
    <UpdateDoctypeModal
      id="updateDoctypeModal"
      ref="updateDoctypeModal"
      v-show="showUpdateDocTypeModal"
      @close="showUpdateDocTypeModal == false"
    >
      <template slot="footer">
        <button
          type="button"
          @click="updateDoctype"
          class="btn btn-primary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="closeUpdateDoctypeModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </UpdateDoctypeModal>
    <ProdPreviewModal
      id="previewModal"
      ref="previewModal"
      :typeId="form.level1TypeId"
      v-show="showPreviewModal"
      @close="showPreviewModal == false"
    >
      <template slot="footer">
        <button
          type="button"
          @click="updateDoctype"
          class="btn btn-primary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="closeUpdateDoctypeModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </ProdPreviewModal>

    <AddControllerTypeModal
      id="addControllerTypeModal"
      ref="addControllerTypeModal"
      v-if="showAddControllerModal"
      @close="showAddControllerModal == false"
    >
      <template slot="footer">
        <button
          type="button"
          @click="saveControllerType"
          class="btn btn-primary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="closeAddControllerTypeModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </AddControllerTypeModal>
    <UpdateControllerTypeModal
      id="updateControllerTypeModal"
      ref="updateControllerTypeModal"
      v-show="showUpdateControllerTypeModal"
      @close="showUpdateControllerTypeModal == false"
    >
      <template slot="footer">
        <button
          type="button"
          @click="updateControllerType"
          class="btn btn-primary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="closeUpdateControllerTypeModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </UpdateControllerTypeModal>
    <ControllerChangeOrderModal
      id="changeOrderModalController"
      ref="changeOrderModalController"
      v-show="showControllerOrderModal"
      @close="showControllerOrderModal == false"
    >
      <template slot="footer">
        <button
          type="button"
          @click="changeOrderController"
          class="btn btn-primary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="closeChangeOrderModalController"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </ControllerChangeOrderModal>

    <AddTpcdModal
      id="addsourceTpcdModal"
      ref="addsourceTpcdModal"
      v-if="showAddTpcdModal"
      :upperControllerId="form.controllerTypeId"
      @close="showAddTpcdModal == false"
    >
      <template slot="footer">
        <button
          type="button"
          @click="saveTpcd"
          class="btn btn-primary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="closeAddTpcdModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </AddTpcdModal>
    <TpcdChangeOrderModal
      id="changeOrderModalTpcd"
      ref="changeOrderModalTpcd"
      v-show="showTpcdOrderModal"
      @close="showTpcdOrderModal == false"
    >
      <template slot="footer">
        <button
          type="button"
          @click="changeOrderTpcd"
          class="btn btn-primary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="closeChangeOrderModalTpcd"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </TpcdChangeOrderModal>
    <UpdateTpcdModal
      id="updateTpcdModal"
      ref="updateTpcdModal"
      v-show="showUpdateTocdModal"
      @close="showUpdateTocdModal == false"
    >
      <template slot="footer">
        <button
          type="button"
          @click="updateTpcd"
          class="btn btn-primary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="closeUpdateTpcdModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </UpdateTpcdModal>
  </div>
</template>

<script>
import {
  getLanguages,
  getProdList,
  changeProdUse,
  deleteProd,
  downExcel,
} from "@/api/prodtype";
import { getModelCodeList, changeModelUse, deleteModel } from "@/api/modelcode";
import { getExhaustCertiList, changeExCertiUse, deleteExCerti } from "@/api/exhaustcerti";
import { getControllerTypeList, changeControllerTypeUse, deleteControllerType } from "@/api/controllertype";
import { getMgmtTpcdList, changeTpcdUse, deleteTpcd} from "@/api/tpcd";
// import $ from "jquery";
import AddProdtypeModal from "@/components/modal/AddProdtypeModal";
import AddModelCodeModal from "@/components/modal/AddModelCodeModal";
import AddExCertificationModal from "@/components/modal/AddExCertificationModal";
import UpdateProdtypeModal from "@/components/modal/UpdateProdtypeModal";
import UpdateModelCodeModal from "@/components/modal/UpdateModelCodeModal";
import UpdateExCertiModal from "@/components/modal/UpdateExCertiModal";
import ModelChangeOrderModal from "@/components/modal/ModelChangeOrderModal";
import ExCertiChangeOrderModal from "@/components/modal/ExCertiChangeOrderModal";
import ProdChangeOrderModal from "@/components/modal/ProdChangeOrderModal";
import UpdateDoctypeModal from "@/components/modal/UpdateDoctypeModal";
import ProdPreviewModal from "@/components/modal/ProdPreviewModal";
import AddControllerTypeModal from "@/components/modal/AddControllerTypeModal";
import UpdateControllerTypeModal from "@/components/modal/UpdateControllerTypeModal";
import ControllerChangeOrderModal from "@/components/modal/ControllerChangeOrderModal";
import TpcdChangeOrderModal from "@/components/modal/TpcdChangeOrderModal";
import AddTpcdModal from "@/components/modal/AddTpcdModal";
import UpdateTpcdModal from "@/components/modal/UpdateTpcdModal";
export default {
  components: {
    ProdPreviewModal,
    ProdChangeOrderModal,
    ExCertiChangeOrderModal,
    ModelChangeOrderModal,
    UpdateExCertiModal,
    UpdateModelCodeModal,
    UpdateProdtypeModal,
    AddExCertificationModal,
    AddModelCodeModal,
    AddProdtypeModal,
    UpdateDoctypeModal,
    AddControllerTypeModal,
    UpdateControllerTypeModal,
    TpcdChangeOrderModal,
    AddTpcdModal,
    UpdateTpcdModal,
    ControllerChangeOrderModal
  },
  data() {
    return {
      prod01List: [],
      prod02List: [],
      modelCodeList: [],
      exhaustCertiList: [],
      controllerTypeList:[],
      sourceTpcdList:[],
      languages: [],
      form: {
        Type01Id: "",
        Type02Id: "",
        modelCodeId: "",
        exhaustCertiId: "",
        selectedLanguage: "en",
        controllerTypeId : "",
        tpcdId : ""
      },
      showProdModal: false,
      showProd2Modal: false,
      showModelModal: false,
      showExModal: false,
      showUpdateProdModal: false,
      showUpdateProdModal2: false,
      showUpdateModelModal: false,
      showUpdateExModal: false,
      showOrderModal1: false,
      showOrderModal2: false,
      showModelOrderModal: false,
      showUpdateDocTypeModal: false,
      showPreviewModal: false,
      showExOrderModal: false,
      showAddControllerModal: false,
      showUpdateControllerTypeModal: false,
      showTpcdOrderModal : false,
      showAddTpcdModal : false,
      showUpdateTocdModal : false,
      showControllerOrderModal : false
    };
  },
  created() {
    this.setUp();
  },
  methods: {
    formReset(){
      this.form.Type01Id = "";
      this.form.Type02Id = "";
      this.form.modelCodeId = "";
      this.form.exhaustCertiId = "";
      this.form.controllerTypeId = "";
      this.form.tpcdId = "";
      this.prod02List = [];
      this.tpcdList = [];
    },
    async downExcel() {
      let result = await downExcel();

      console.log(result);
      const url = window.URL.createObjectURL(
        new Blob([result.data], { type: result.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.download = "ProductInfo.xls";
      link.click();
      window.URL.revokeObjectURL(url);
    },
    async deleteType(id, type) {
      if (!confirm(this.$t("alert.delete"))) return;
      if (type === "prod") {
        await deleteProd({ prodId: id });
      } else if (type === "model") {
        await deleteModel({ modelcodeId: id });
      } else if (type === "exhaust") {
        await deleteExCerti({ exhaustCertiId: id });
      } else if (type === "controller"){
        await deleteControllerType({ controllerId: id });
      } else if(type === "tpcd"){
        this.deleteTpcd(id);
      }
      await this.fetchData();
    },
    async toggleUseYN(id, useYn, type) {
      if (type === "prod") {
        changeProdUse({ id: id, useYn: useYn });
      } else if (type === "model") {
        changeModelUse({ id: id, useYn: useYn });
      } else if (type === "exhaust") {
        changeExCertiUse({ id: id, useYn: useYn });
      } else if(type === "controller" ){
        changeControllerTypeUse({ id: id, useYn: useYn });
      } else if(type=== "tpcd"){
        changeTpcdUse({ id: id, useYn: useYn });
      }
    },
    getProdList: async function () {
      let response = await getProdList(this.form.selectedLanguage, 1, "");
      this.prod01List = response.data.prodList;
    },
    getModelCodeList: async function () {
      let modelCodeResponse = await getModelCodeList(this.form.selectedLanguage);
      this.modelCodeList = modelCodeResponse.data.list;
    },
    getExhuastCertiList: async function () {
      let exhaustCertiResponse = await getExhaustCertiList(this.form.selectedLanguage);
      this.exhaustCertiList = exhaustCertiResponse.data.list;
    },
    async showPreviewPopup(doctypeId) {
      await this.$refs.previewModal.fetchData(doctypeId);
      this.showPreviewModal = true;
      // $('#previewModal').modal('show');
    },
    async updateDoctype() {
      await this.$refs.updateDoctypeModal.update();
      await this.fetchData();
      this.showPreviewModal = false;
      this.showUpdateDocTypeModal = false;
    },
    closeUpdateDoctypeModal() {
      this.showUpdateDocTypeModal = false;
      // 이미지 미리보기 모달도 이 핸들러로 닫는다. (v-show="showPreviewModal")
      this.showPreviewModal = false;
      // $('#updateDoctypeModal').modal('hide');
    },
    async setUp() {
      try {
        const langList = await getLanguages();
        this.languages = langList.data.languages;
        this.form.selectedLanguage = "en";

        this.getProdList();
        this.getModelCodeList();
        this.getExhuastCertiList();
        this.getControllerTypeList();
      } catch (error) {
        console.log(error);
      }
    },
    async fetchData() {
      try {
        // level 2 초기화
        this.prod02List = [];
        this.tpcdList = [];

        this.getProdList();
        this.getModelCodeList();
        this.getExhuastCertiList();
        this.getControllerTypeList();
        
      } catch (error) {
        console.log(error);
      }
    },
    async changeLang() {
      await this.fetchData();
    },
    async changeType01(doctypeId) {
      this.formReset();
      this.prod02List = [];
      let response = await getProdList(this.form.selectedLanguage, 2, doctypeId);
      this.prod02List = response.data.prodList;
      this.form.Type02Id = "";
      this.form.Type01Id = doctypeId;
    },
    async changeType02(doctypeId) {
      this.form.Type02Id = doctypeId;
    },
    async changeModelCode(doctypeId) {
      this.form.modelCodeId = doctypeId;
    },
    async changeExCerti(doctypeId) {
      this.form.exhaustCertiId = doctypeId;
    },
    async showAdd01Popup() {
      // await this.$refs.addProdtypeModal.reset();
      await this.$refs.addProdtypeModal.fetchProdTypeForm("", 1);
      this.showProdModal = true;
    },
    async showAdd02Popup() {
      if (this.form.Type01Id === "") {
        alert(this.$t("alert.pleaseSelectAType"));
        return;
      }
      // await this.$refs.addProdtypeModal.reset();
      await this.$refs.addProdtype02Modal.fetchProdTypeForm(this.form.Type01Id, 2);
      this.showProd2Modal = true;
    },
    async showAddModelCodePopup() {
      // await this.$refs.addProdtypeModal.reset();
      await this.$refs.addModelCodeModal.fetchProdTypeForm(this.form.Type01Id, 2);
      this.showModelModal = true;
    },
    async showAddExCertificationPopup() {
      // await this.$refs.addProdtypeModal.reset();
      await this.$refs.addExCertificationModal.fetchProdTypeForm(this.form.Type01Id, 2);
      this.showExModal = true;
    },
    closeAddProdtypeModal() {
      this.showProdModal = false;
    },
    closeAddProdtype02Modal() {
      this.showProd2Modal = false;
    },
    closeAddModelCodeModal() {
      this.showModelModal = false;
    },
    closeAddExCertificationModal() {
      this.showExModal = false;
    },
    async saveProdType() {
      let data = await this.$refs.addProdtypeModal.save();
      if (data != true) {
        alert(this.$t(data));
        return;
      } else {
        alert(this.$t("alert.savedSuccessfully"));
        this.$refs.addProdtypeModal.reset();
        await this.fetchData();
        this.showProdModal = false;
      }
    },
    async saveProdType02() {
      let data = await this.$refs.addProdtype02Modal.save();
      if (data != true) {
        alert(this.$t(data));
        return;
      } else {
        alert(this.$t("alert.savedSuccessfully"));
        this.$refs.addProdtype02Modal.reset();
        await this.fetchData();
        await this.changeType01(this.form.Type01Id);
        this.showProd2Modal = false;
      }
    },
    async saveModelCode() {
      let data = await this.$refs.addModelCodeModal.save();
      if (data == false) {
        alert(this.$t("alert.ErrorPlzcontactManager"));
        return;
      } else if (data == true) {
        alert(this.$t("alert.savedSuccessfully"));
        this.$refs.addModelCodeModal.reset();
        await this.fetchData();
        await this.changeType01(this.form.Type01Id);
        this.showModelModal = false;
      } else if (data == "exist") {
        alert(this.$t("alert.alreadyExist"));
      } else if (data == "value") {
        alert(this.$t("alert.plzCheckAllValues"));
      }
    },
    async saveExCertification() {
      let data = await this.$refs.addExCertificationModal.save();
      if (data != true) {
        alert(this.$t(data));
        return;
      } else {
        alert(this.$t("alert.savedSuccessfully"));
        this.$refs.addExCertificationModal.reset();
        await this.fetchData();
        await this.changeType01(this.form.Type01Id);
        this.showExModal = false;
      }
    },
    async showUpdateProd01Popup(id) {
      if (this.form.Type01Id === "") {
        alert(this.$t("alert.pleaseSelectAType"));
      } else {
        await console.log(id);
        await this.$refs.updateProdtype01Modal.fetchData(id);
        this.showUpdateProdModal = true;
      }
    },
    async showUpdateProd02Popup(id) {
      if (this.form.Type02Id === "") {
        alert(this.$t("alert.pleaseSelectAType"));
      } else {
        await console.log(id);
        await this.$refs.updateProdtype02Modal.fetchData(id);
        this.showUpdateProdModal2 = true;
      }
    },
    async showUpdateModelCodePopup(id) {
      if (this.form.modelCodeId === "") {
        alert(this.$t("alert.pleaseSelectAType"));
      } else {
        await console.log(id);
        await this.$refs.updateModelCodeModal.fetchData(id);
        this.showUpdateModelModal = true;
      }
    },
    async showUpdateExCertiPopup(id) {
      if (this.form.exhaustCertiId === "") {
        alert(this.$t("alert.pleaseSelectAType"));
      } else {
        await this.$refs.updateExCertiModal.fetchData(id);
        this.showUpdateExModal = true;
      }
    },
    closeUpdateProdtype01Modal() {
      this.showUpdateProdModal = false;
    },
    closeUpdateProdtype02Modal() {
      this.showUpdateProdModal2 = false;
    },
    closeUpdateModelCodeModal() {
      this.showUpdateModelModal = false;
    },
    closeUpdateExCertiModal() {
      this.showUpdateExModal = false;
    },
    async updateProdtype01() {
      let data = await this.$refs.updateProdtype01Modal.update();
      if (data != true) {
        alert(this.$t(data));
        return;
      } else {
        alert(this.$t("alert.changedSuccessfully"));
      }
      await this.fetchData();
      this.showUpdateProdModal = false;
    },
    async updateProdtype02() {
      let data = await this.$refs.updateProdtype02Modal.update();
      if (data != true) {
        alert(this.$t(data));
        return;
      } else {
        alert(this.$t("alert.changedSuccessfully"));
      }
      await this.fetchData();
      this.showUpdateProdModal2 = false;
    },
    async updateModelCode() {
      let data = await this.$refs.updateModelCodeModal.update();
      if (data != true) {
        alert(this.$t(data));
        return;
      } else {
        alert(this.$t("alert.changedSuccessfully"));
      }
      await this.fetchData();
      this.showUpdateModelModal = false;
    },
    async updateExCerti() {
      let data = await this.$refs.updateExCertiModal.update();
      if (data != true) {
        alert(this.$t(data));
        return;
      } else {
        alert(this.$t("alert.changedSuccessfully"));
      }
      await this.fetchData();
      this.showUpdateExModal = false;
    },
    closeChangeOrderModal01() {
      this.showOrderModal1 = false;
    },
    closeChangeOrderModal02() {
      this.showOrderModal2 = false;
    },
    closeModelChangeOrderModal() {
      this.showModelOrderModal = false;
    },
    closeExCertiChangeOrderModal() {
      this.showExOrderModal = false;
    },
    async showChangeOrder01() {
      await this.$refs.changeOrderModal01.fetchData(this.form.selectedLanguage, 1, "");
      this.showOrderModal1 = true;
    },
    async showChangeOrder02() {
      if (this.form.Type01Id === "") {
        alert(this.$t("alert.pleaseSelectAType"));
      } else {
        await this.$refs.changeOrderModal02.fetchData(
          this.form.selectedLanguage,
          2,
          this.form.Type01Id
        );
        this.showOrderModal2 = true;
      }
    },
    async showChangeOrderModel() {
      await this.$refs.modelChangeOrderModal.fetchData(this.form.selectedLanguage);
      this.showModelOrderModal = true;
    },
    async showChangeOrderExCerti() {
      await this.$refs.exCertiChangeOrderModal.fetchData(this.form.selectedLanguage);
      this.showExOrderModal = true;
    },

    async changeOrder01() {
      await this.$refs.changeOrderModal01.saveOrder();
      await this.fetchData();
      this.showOrderModal1 = false;
    },
    async changeOrder02() {
      await this.$refs.changeOrderModal02.saveOrder();
      await this.fetchData();
      this.showOrderModal2 = false;
    },
    async changeModelCodeOrder() {
      await this.$refs.modelChangeOrderModal.saveOrder();
      await this.fetchData();
      this.showModelOrderModal = false;
    },
    async changeExCertiOrder() {
      await this.$refs.exCertiChangeOrderModal.saveOrder();
      await this.fetchData();
      this.showExOrderModal = false;
    },
    // ---------------- 2023.12 Controller Type & source TPCD 추가
    async changeControllerTypeId(id){
      this.formReset();
      this.sourceTpcdList = [];
      let response = await getMgmtTpcdList(id);
      this.sourceTpcdList = response.data.tpcdList;
      this.form.controllerTypeId = id;
      this.form.tpcdId = "";
    },
    async saveControllerType() {
      let data = await this.$refs.addControllerTypeModal.save();
      if (data != true) {
        alert(this.$t(data));
        return;
      } else {
        alert(this.$t("alert.savedSuccessfully"));
        this.showAddControllerModal = false;
        this.$refs.addControllerTypeModal.reset();
        await this.fetchData();
      }
    },
    getControllerTypeList: async function () {
      let response = await getControllerTypeList();
      this.controllerTypeList = response.data.controllerTypeList;
    },
    showAddControllerType(){
      this.showAddControllerModal = true;
    },
    closeAddControllerTypeModal(){
      this.showAddControllerModal = false;
    },
    async showUpdateControllerType(id) {
      if (this.form.controllerTypeId === "") {
        alert(this.$t("alert.pleaseSelectAType"));
      } else {
        await this.$refs.updateControllerTypeModal.fetchData(id);
        this.showUpdateControllerTypeModal = true;
      }
    },
    closeUpdateControllerTypeModal(){
      this.showUpdateControllerTypeModal = false;
    },
    async updateControllerType() {
      let data = await this.$refs.updateControllerTypeModal.update();
      if (data != true) {
        alert(this.$t(data));
        return;
      } else {
        alert(this.$t("alert.changedSuccessfully"));
      }
      await this.fetchData();
      this.showUpdateControllerTypeModal = false;
    },
    // order
    async showChangeOrderControllerType(){
      await this.$refs.changeOrderModalController.fetchData();
      this.showControllerOrderModal = true;
    },
    async changeOrderController(){
        await this.$refs.changeOrderModalController.saveOrder();
        await this.fetchData();
        this.showControllerOrderModal = false;
    },
    closeChangeOrderModalController(){
      this.showControllerOrderModal = false;
    },
    //--------------------------- tpcd 
    // get
    getTpcdList: async function () {
      let response = await getMgmtTpcdList();
      this.sourceTpcdList = response.data.tpcdList;
    },
    changeTpcdId(id){
      this.form.tpcdId = id;
    },
    // order
    async showChangeOrderTpcd(){
      if (this.form.controllerTypeId === "") {
        alert(this.$t("alert.pleaseSelectAType"));
        return;
      }
      await this.$refs.changeOrderModalTpcd.fetchData(this.form.controllerTypeId);
      this.showTpcdOrderModal = true;
    },
    async changeOrderTpcd(){
      await this.$refs.changeOrderModalTpcd.saveOrder();
      await this.fetchData();
      if (this.form.controllerTypeId === "") {
          this.tpcdList = [];
      } else {
        let response = await getMgmtTpcdList(this.form.controllerTypeId);
        this.sourceTpcdList = response.data.tpcdList;
      }
      this.showTpcdOrderModal = false;
    },
    closeChangeOrderModalTpcd(){
      this.showTpcdOrderModal = false;
    },
    // add
    async saveTpcd(){
      let data = await this.$refs.addsourceTpcdModal.save();
      if (data != true) {
        alert(this.$t(data));
        return;
      } else {
        alert(this.$t("alert.savedSuccessfully"));
        this.showAddTpcdModal = false;
        this.$refs.addsourceTpcdModal.reset();
        await this.fetchData();
        if (this.form.controllerTypeId === "") {
          this.tpcdList = [];
        } else {
          let response = await getMgmtTpcdList(this.form.controllerTypeId);
          this.sourceTpcdList = response.data.tpcdList;
        }
      }
    },
    closeAddTpcdModal(){
      this.showAddTpcdModal = false;
    },
    showAddTpcdPopup(){
      if (this.form.controllerTypeId === "") {
        alert(this.$t("alert.pleaseSelectAType"));
        return;
      }
      this.showAddTpcdModal = true;
    },
    // update
    async showUpdateTpcdPopup(id){
      if (this.form.tpcdId === "") {
        alert(this.$t("alert.pleaseSelectAType"));
      } else {
        await this.$refs.updateTpcdModal.fetchData(id);
        this.showUpdateTocdModal = true;
      }
    },
    async updateTpcd(){
      let data = await this.$refs.updateTpcdModal.update();
      if (data != true) {
        alert(this.$t(data));
        return;
      } else {
        alert(this.$t("alert.changedSuccessfully"));
      }
      await this.fetchData();
      if (this.form.controllerTypeId === "") {
        this.tpcdList = [];
      } else {
        let response = await getMgmtTpcdList(this.form.controllerTypeId);
        this.sourceTpcdList = response.data.tpcdList;
      }
      this.showUpdateTocdModal = false;
    },
    closeUpdateTpcdModal(){
      this.showUpdateTocdModal = false;
    },
    async deleteTpcd(id){
      if(this.form.tpcdId == ""){
        alert(this.$t("alert.pleaseSelectAType"));
      }else{
        await deleteTpcd({ tpcdId : id });
        if (this.form.controllerTypeId === "") {
          this.tpcdList = [];
        } else {
          let response = await getMgmtTpcdList(this.form.controllerTypeId);
          this.sourceTpcdList = response.data.tpcdList;
        }
      }
    },
  },
};
</script>

<style></style>
